import script from "./EntitlementPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EntitlementPage.vue?vue&type=script&setup=true&lang=js"

import "./EntitlementPage.vue?vue&type=style&index=0&id=73d02294&scoped=true&lang=css"
script.__scopeId = "data-v-73d02294"

export default script